// extracted by mini-css-extract-plugin
export var fullHeightState = "_4f-7";
export var headerCell = "_4f-1";
export var loadingStateCell = "_4f-4";
export var rowWrapper = "_4f-3";
export var standaloneTable = "_4f-8";
export var standaloneTableWithBodyFill = "_4f-9";
export var stateCell = "_4f-5";
export var table = "_4f-0";
export var tableBodyFiller = "_4f-6";
export var white = "_4f-2";